import React, { useState, useEffect } from 'react';
import AdminNavbar from '../components/AdminNavbar';
import { fetchFacilities, createFacility, updateFacility, deleteFacility } from '../utils/facilitiesApi';
import './AdminGallery.css';

export default function AdminFacilities() {
    const [facilities, setFacilities] = useState([]);
    const [title, setTitle] = useState('');
    const [desc, setDesc] = useState('');
    
    const [editingId, setEditingId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });

    const loadFacilities = async () => {
        const data = await fetchFacilities();
        setFacilities(data || []);
    };

    useEffect(() => {
        loadFacilities();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            setMessage({ type: '', text: editingId ? 'Updating facility...' : 'Saving facility...' });
            
            if (editingId) {
                await updateFacility(editingId, { title, desc });
                setMessage({ type: 'success', text: 'Success! Facility updated.' });
                setEditingId(null);
            } else {
                await createFacility({ title, desc });
                setMessage({ type: 'success', text: 'Success! Facility added.' });
            }
            
            setTitle('');
            setDesc('');
            loadFacilities();
        } catch (error) {
            setMessage({ type: 'danger', text: `Failed: ${error.message}` });
        } finally {
            setLoading(false);
        }
    }

    const handleEdit = (item) => {
        setEditingId(item.id);
        setTitle(item.title || '');
        setDesc(item.desc || '');
    }

    const cancelEdit = () => {
        setEditingId(null);
        setTitle('');
        setDesc('');
    }

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this facility?")) return;
        try {
            await deleteFacility(id);
            setMessage({ type: 'success', text: 'Facility deleted!' });
            loadFacilities();
        } catch(error) {
            setMessage({ type: 'danger', text: 'Failed to delete.' });
        }
    }

    return (
        <div className="admin-gallery-container pt-5 pb-5">
            <div className="container">
                <AdminNavbar />

                {message.text && (
                    <div className={`alert alert-${message.type} alert-dismissible fade show`} role="alert">
                        {message.text}
                        <button type="button" className="close" onClick={() => setMessage({type: '', text: ''})} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                )}

                <div className="row">
                    <div className="col-lg-4 mb-4">
                        <div className="admin-card upload-card">
                            <h4>{editingId ? 'Edit Facility' : 'Add New Facility'}</h4>
                            <p className="text-muted" style={{fontSize: '0.9rem'}}>{editingId ? 'Update this facility.' : 'Add a new facility feature to the home page.'}</p>
                            <form onSubmit={handleSubmit}>
                                <div className="form-group mt-3">
                                    <label>Facility Title</label>
                                    <input type="text" className="form-control" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="e.g. Digital Classroom" required />
                                </div>
                                <div className="form-group mt-3">
                                    <label>Description</label>
                                    <textarea className="form-control" rows="4" value={desc} onChange={(e) => setDesc(e.target.value)} placeholder="Short description..." required />
                                </div>
                                
                                <button type="submit" className="upload-btn w-100 mt-4" disabled={loading}>
                                    {loading ? 'Saving...' : editingId ? 'Update Facility' : 'Add Facility'}
                                </button>
                                {editingId && (
                                    <button type="button" onClick={cancelEdit} className="btn btn-secondary w-100 mt-2 font-weight-bold" disabled={loading}>
                                        Cancel Edit
                                    </button>
                                )}
                            </form>
                        </div>
                    </div>

                    <div className="col-lg-8">
                        <div className="admin-card">
                            <h4>Current Facilities</h4>
                            <div className="row admin-grid mt-4">
                                {facilities.map((item) => (
                                    <div className="col-md-6 mb-4" key={item.id}>
                                        <div className="card shadow-sm border-0 h-100">
                                            <div className="card-body">
                                                <div className="d-flex align-items-center mb-3">
                                                    <i className="flaticon-050-fence h3 text-primary mb-0 mr-3" />
                                                    <h5 className="font-weight-bold m-0 text-dark">{item.title}</h5>
                                                </div>
                                                <p className="m-0 text-muted" style={{fontSize: '0.9rem'}}>{item.desc}</p>
                                                
                                                <div className="d-flex justify-content-between mt-4" style={{gap: '10px'}}>
                                                    <button onClick={() => handleEdit(item)} className="btn btn-sm btn-outline-primary flex-fill font-weight-bold">
                                                        ✏️ Edit
                                                    </button>
                                                    <button onClick={() => handleDelete(item.id)} className="btn btn-sm btn-outline-danger flex-fill font-weight-bold">
                                                        🗑️ Delete
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
